import React from 'react'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'

const Cart = () => {
  const { t } = useTranslation();

  return (
<div>
  <main className="page-content page-content-ones">
    <div className="tm-section tm-my-account-area bg-white tm-padding-section wishlist-section-ones">
      <div className="container">
        <div className="tm-myaccount">
          <div className="tab-content" id="account-ontent">
            <div className="tab-pane fade show active" id="account-dashboard" role="tabpanel" aria-labelledby="account-dashboard-tab">
              <div className="tm-myaccount-dashboard1">
                <div className="cart-box-two">
                  <div className="row">
                    <div className="col-lg-8 col-md-6">
                      <div className="my-wishlist my-wishlist-one">
                        <h4>{t("C1")}<span>{t("C2")}</span></h4>
                      </div>
                      {/* <div class="cart-box1 cart-box11">
													<div class="row" style="align-items:center;">
														<div class="col-lg-6 col-6">
															<div class="cart-text cart-text1">
																<h2>Deliver to: <span> 303805</span></h2>
															</div>
														</div>
														<div class="col-lg-6 col-6">
															<div class="cart-textaa">
																<button type="button" class="address-change-a address-change-six" data-bs-toggle="modal" data-bs-target="#exampleModal">
																	CHANGE ADDRESS
																</button>
																<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
																	<div class="modal-dialog modal-dialog-centered">
																		<div class="modal-content">
																			<div class="modal-header">
																				<h5 class="modal-title" id="exampleModalLabel">Select Delivery Address</h5>
																				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
																			</div>
																			<div class="modal-body">
																				<div class="delivery-address-menBox">
																					<div class="form-check form-check-one">
																						<input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1">
																						<label class="form-check-label form-check-label-one" for="flexRadioDefault1">
																							Krishan <span>Home</span>
																						</label>
																						<div class="address-box1">
																							<h2>+91 9999999999</h2>
																							<p>C-1,Ground Floor, Chittora Appartment, Plot No A-4 Tilak Marg C-scheme Jaipur, 302001, Jaipur, Rajasthan 302001</p>
																						</div>
																					</div>
																					<div class="form-check form-check-one">
																						<input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" checked>
																						<label class="form-check-label form-check-label-one" for="flexRadioDefault2">
																							Mohit <span>Home</span>
																						</label>
																						<div class="address-box1">
																							<h2>+91 9999999999</h2>
																							<p>C-1,Ground Floor, Chittora Appartment, Plot No A-4 Tilak Marg C-scheme Jaipur, 302001, Jaipur, Rajasthan 302001</p>
																						</div>
																					</div>
																				</div>
																				<div class="cart-text cart-text1 cart-text12">
																					
																					<a href="#">
																						<div class="add-new-address text-center" data-bs-toggle="modal" data-bs-target="#exampleModal22">+ Add New Address</div>
																					</a>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
																<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
																	<div class="modal-dialog modal-dialog-centered">
																		<div class="modal-content">
																			<div class="modal-header">
																				<h5 class="modal-title" id="exampleModalLabel">Select Delivery Address</h5>
																				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
																			</div>
																			<div class="modal-body">
																				<div class="cart-box1 cart-box11 cart-box12">
																					<div class="row">
																						<div class="col-lg-12">
																							<div class="cart-text cart-text1 cart-text12">
																								<form class="full-form">
																									<h2><span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"></path></svg> Krishan 
																										<a class="home-button">Home</a>
																									</span>
																									<p>bagwara, Bagwara</p>
																									<span>Jaipur, Rajasthan - </span>
																									<span>303805</span>
																									<div class="delivery-text">
																										<span class="addressServiceability-base-bullet"> • </span>
																										<span> Pay on Delivery available</span>
																									</div>
																									<div class="addressBlocks-base-btns">
																										<button class="addressBlocks-base-remove" data-action="remove">Remove</button><button class="addressBlocks-base-edit" data-action="showModal">Edit</button>
																									</div>

																								</h2></form>
																							</div>
																						</div>
																					</div>
																				</div>
																				<div class="cart-text cart-text1 cart-text12">
																					<a href="#">
																						<div class="add-new-address text-center">+ Add New Address</div>
																					</a>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
																<div class="modal fade" id="exampleModal22" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
																	<div class="modal-dialog modal-dialog-scrollable">
																		<div class="modal-content">
																			<div class="modal-header">
																				<h5 class="modal-title" id="exampleModalLabel">ADD NEW ADDRESS</h5>
																				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
																			</div>
																			<div class="modal-body">
																				<div class="cart-box1 cart-box11">
																					<div class="row">
																						<div class="col-lg-12">
																							<div class="cart-box5">
																								<div class="row">
																									<div class="col-lg-12">
																										<div class="cart-text cart-text1 cart-text12">
																											<form class="full-form">
																												<h2><span> Contact Details</span></h2>
																												<div class="row">
																													<div class="col-lg-12 col-md-6">
																														<input class="card-form" type="text" placeholder="Name*">
																													</div>
																													<div class="col-lg-12 col-md-6">
																														<input class="card-form" type="text" placeholder="Mobile No*">
																													</div>
																												</div>
																												<h2><span> ADDRESS</span></h2>
																												<div class="row">
																													<div class="col-lg-12 col-md-6">
																														<input class="card-form" type="text" placeholder="Pin Code*">
																													</div>
																													<div class="col-lg-12 col-md-6">
																														<input class="card-form" type="text" placeholder="Address (House No, Building, Street, Area)*">
																													</div>
																													<div class="col-lg-12 col-md-6">
																														<input class="card-form" type="text" placeholder="Locality / Town*">
																													</div>
																												</div>
																												<div class="form-twobutton">
																													<div class="form-left">
																														<label>City / District*</label>
																													</div>
																													<div class="form-left">
																														<label>State*</label>
																													</div>
																												</div>
																												<h2><span> SAVE ADDRESS AS</span></h2>
																												<div class="address-btn">
																													<div class="address-btn1">
																														Home
																													</div>
																													<div class="address-btn1">
																														Work
																													</div>
																												</div><br>
																												<div class="check-boxbtn check-boxbtn-aa">
																													<input type="checkbox" id="vehicle1" name="vehicle1" value="Bike">
																													<label for="vehicle1"> Make this my default address</label>
																												</div>
																											</form>
																										</div>
																									</div>
																								</div>
																							</div>
																						</div>
																					</div>
																				</div>
																				<div class="cart-text cart-text1 cart-text12">
																					<a href="#">
																						<div class="add-new-address add-new-address11 text-center">ADD ADDRESS</div>
																					</a>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div> */}
                      <div className="cart-box1">
                        <div className="row">
                          <div className="col-lg-2 col-3">
                            <div className="cart-photo">
                              <h2><img src="assets/images/card-photo.jpg" /></h2>
                            </div>
                          </div>
                          <div className="col-lg-10 col-9">
                            <div className="cart-text">
                              <button className="tm-wishlist-removeproduct remove-btn"><i className="ion-close" /></button>
                              <h2>{t("C3")}</h2>
                              <h3> ₹110 <span>₹210</span></h3>
                              {/* <h4>
																	<span>Size: 10XL</span>
																</h4>
																<h4>
																	<span>Weight: 1.3g</span>
																</h4> */}
                              <h4>
                                <div className="quantity">
                                  <button className="minus" aria-label="Decrease">−</button>
                                  <input type="number" className="input-box" defaultValue={1} min={1} max={10} />
                                  <button className="plus" aria-label="Increase">+</button>
                                </div>
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6 ">
                      <div className="my-wishlist my-wishlist-one">
                        <h4>{t("C4")}</h4>
                      </div>
                      <div className="cart-right">
                        <div className="cart-right-inner">
                          <div className="my-wishlist my-wishlist-one">
                            <h4>{t("C5")}</h4>
                          </div>
                          <div className="cart-box3">
                            <div className="row" style={{alignItems: 'center'}}>
                              <div className="col-lg-6 col-6">
                                <div className="cart-text cart-text1">
                                  <h2><svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 18 18" className="coupons-base-couponIcon"><g fill="none" fillRule="evenodd" transform="rotate(45 6.086 5.293)"><path stroke="#000" d="M17.5 10V1a1 1 0 0 0-1-1H5.495a1 1 0 0 0-.737.323l-4.136 4.5a1 1 0 0 0 0 1.354l4.136 4.5a1 1 0 0 0 .737.323H16.5a1 1 0 0 0 1-1z" /><circle cx="5.35" cy="5.35" r="1.35" fill="#000" fillRule="nonzero" /></g></svg>Apply Coupons</h2>
                                </div>
                              </div>
                              <div className="col-lg-6 col-6">
                                <div className="cart-textaa">
                                  {/* Button trigger modal */}
                                  <button type="button" className="address-change-a address-change-five" data-bs-toggle="modal" data-bs-target="#exampleModal11">
                                  {t("C6")}
                                  </button>
                                  {/* Modal */}
                                  <div className="modal fade" id="exampleModal11" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                                    <div className="modal-dialog modal-dialog-centered">
                                      <div className="modal-content">
                                        <div className="modal-header">
                                          <h5 className="modal-title" id="exampleModalLabel">{t("C7")}</h5>
                                          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                        </div>
                                        <div className="modal-body">
                                          <div className="cart-box12 coupon-men-box">
                                            <div className="row">
                                              <div className="col-lg-12">
                                                <div className="coupon-base-validCouponContainer apply-coupon-men">
                                                  <div className>
                                                    <div className="row">
                                                      <div className="col-lg-6 col-6">
                                                        {/* <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"> */}
                                                        <label className="form-check-label" htmlFor="flexCheckDefault">
                                                          <span className="coupon-base-labelUnchecked ">{t("C8")}</span>
                                                        </label>
                                                      </div>
                                                      <div className="col-lg-6 col-6 coupon-apply-right">
                                                        <label>
                                                          <div className="modal-footer-one1"><a href="#">
                                                              <div className="coupons-btn-one">{t("C6")}</div></a>
                                                          </div>
                                                        </label>
                                                      </div>
                                                    </div>
                                                    <div className="coupon-base-infoContainer">
                                                      <div className="coupon-base-benefit coupon-base-two">
                                                        <span>{t("C9")} </span><span className="coupon-base-amount ">
                                                          <svg width={7} height={9} className="coupon-base-rupeeIcon">
                                                            <g clipPath="url(#a)"><path fillRule="nonzero" d="M.967 4.7 3.5 9h1.255L2.19 4.883c.652-.09 1.174-.298 1.566-.624.4-.335.628-.8.685-1.395h1.591V2.08H4.418a1.912 1.912 0 0 0-.233-.746 2.012 2.012 0 0 0-.465-.55h2.313V0H.967v.783h.269c.416 0 .767.045 1.052.135.294.09.527.232.698.428.171.188.286.433.343.734H.967v.784H3.34c-.033.326-.135.583-.306.77-.171.188-.408.323-.71.404a4.134 4.134 0 0 1-1.089.123h-.27v.538Z" /></g><defs><clipPath id="a">
                                                                <path fillRule="nonzero" d="M0 0h7v9H0z" />
                                                              </clipPath></defs></svg>301</span>
                                                      </div>
                                                      <div className="coupon-base-extraInfo ">
                                                        <div className="readmore-base-mainContainer ">
                                                          <div className="readmore-base-fullWidthContainer readmore-base-two"> {t("C10")}
                                                          </div></div><div className="coupon-base-expiryBlock readmore-base-two">{t("C11")}: 
                                                          <span className="coupon-base-expiryDate">{t("C12") } </span>
                                                          <span className="coupon-base-expiryTime">01:22 PM</span>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="cart-box12 coupon-men-box">
                                            <div className="row">
                                              <div className="col-lg-12">
                                                <div className="coupon-base-validCouponContainer apply-coupon-men">
                                                  <div className>
                                                    <div className="row">
                                                      <div className="col-lg-6 col-6">
                                                        {/* <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"> */}
                                                        <label className="form-check-label" htmlFor="flexCheckDefault">
                                                          <span className="coupon-base-labelUnchecked ">{t("C8")}</span>
                                                        </label>
                                                      </div>
                                                      <div className="col-lg-6 col-6 coupon-apply-right">
                                                        <label>
                                                          <div className="modal-footer-one1"><a href="#">
                                                              <div className="coupons-btn-one">{t("C6")}</div></a>
                                                          </div>
                                                        </label>
                                                      </div>
                                                    </div>
                                                    <div className="coupon-base-infoContainer">
                                                      <div className="coupon-base-benefit coupon-base-two">
                                                        <span>{t("C9")} </span><span className="coupon-base-amount ">
                                                          <svg width={7} height={9} className="coupon-base-rupeeIcon">
                                                            <g clipPath="url(#a)"><path fillRule="nonzero" d="M.967 4.7 3.5 9h1.255L2.19 4.883c.652-.09 1.174-.298 1.566-.624.4-.335.628-.8.685-1.395h1.591V2.08H4.418a1.912 1.912 0 0 0-.233-.746 2.012 2.012 0 0 0-.465-.55h2.313V0H.967v.783h.269c.416 0 .767.045 1.052.135.294.09.527.232.698.428.171.188.286.433.343.734H.967v.784H3.34c-.033.326-.135.583-.306.77-.171.188-.408.323-.71.404a4.134 4.134 0 0 1-1.089.123h-.27v.538Z" /></g><defs><clipPath id="a">
                                                                <path fillRule="nonzero" d="M0 0h7v9H0z" />
                                                              </clipPath></defs></svg>301</span>
                                                      </div>
                                                      <div className="coupon-base-extraInfo ">
                                                        <div className="readmore-base-mainContainer ">
                                                          <div className="readmore-base-fullWidthContainer readmore-base-two">{t("C10")}
                                                          </div></div><div className="coupon-base-expiryBlock readmore-base-two">{t("C11")} 
                                                          <span className="coupon-base-expiryDate">{t("C12")}  </span>
                                                          <span className="coupon-base-expiryTime">01:22 PM</span>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="cart-text cart-text1 cart-text12">
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/* Modal */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="return-text-men">
                          <h4 className="return-text">
                            <span><svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.63639 6.99013C6.84386 7.1976 6.84386 7.53397 6.63639 7.74143L5.7725 8.60533H8.27232C9.21251 8.60533 9.97949 7.84333 9.97949 6.89824C9.97949 5.95914 9.21859 5.19824 8.27949 5.19824H6.89116C6.59776 5.19824 6.35991 4.96039 6.35991 4.66699C6.35991 4.37359 6.59776 4.13574 6.89116 4.13574H8.27949C9.80539 4.13574 11.042 5.37234 11.042 6.89824C11.042 8.43232 9.79722 9.66783 8.27241 9.66783H5.77242L6.63639 10.5318C6.84386 10.7393 6.84386 11.0756 6.63639 11.2831C6.42893 11.4906 6.09256 11.4906 5.88509 11.2831L4.11426 9.51227C4.0417 9.43971 3.99452 9.35138 3.97271 9.25831C3.96352 9.21922 3.95866 9.17846 3.95866 9.13658C3.95866 9.05996 3.97488 8.98713 4.00407 8.92134C4.02519 8.87367 4.05366 8.82847 4.08949 8.78745C4.09828 8.77738 4.10745 8.76764 4.11697 8.75826L5.88509 6.99013C6.09256 6.78267 6.42893 6.78267 6.63639 6.99013Z" fill="#282C3F" /><path fillRule="evenodd" clipRule="evenodd" d="M0.416992 7.50033C0.416992 3.58831 3.58831 0.416992 7.50033 0.416992C11.4123 0.416992 14.5837 3.58831 14.5837 7.50033C14.5837 11.4123 11.4123 14.5837 7.50033 14.5837C3.58831 14.5837 0.416992 11.4123 0.416992 7.50033ZM7.50033 1.47949C4.17511 1.47949 1.47949 4.17511 1.47949 7.50033C1.47949 10.8255 4.17511 13.5212 7.50033 13.5212C10.8255 13.5212 13.5212 10.8255 13.5212 7.50033C13.5212 4.17511 10.8255 1.47949 7.50033 1.47949Z" fill="#282C3F" /></svg>{t("C48")}</span> {t("C49")}
                          </h4>
                          <h4 className="return-text">
                            <span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">{/*!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.*/}<path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z" /></svg>Delivery by</span> 10 Apr 2024
                          </h4>
                        </div>
                        <div className="my-wishlist my-wishlist-one">
                          <h4>{t("C13")}</h4>
                        </div>
                        <div className="cart-box2">
                          <div className="row">
                            <div className="col-lg-6 col-6">
                              <div className="two-left">
                                <h2>{t("C14")}</h2>
                              </div>
                            </div>
                            <div className="col-lg-6 col-6">
                              <div className="two-right">
                                <h2>+ ₹460</h2>
                              </div>
                            </div>
                          </div>
                          <div className="row card-right-center">
                            <div className="col-lg-6 col-6">
                              <div className="two-left">
                                <h2>{t("C15")}</h2>
                              </div>
                            </div>
                            <div className="col-lg-6 col-6">
                              <div className="two-right">
                                <h2 className="discount-text">- ₹49</h2>
                              </div>
                            </div>
                          </div>
                          <div className="row card-right-center">
                            <div className="col-lg-6 col-6">
                              <div className="two-left">
                                <h2>{t("C16")}</h2>
                              </div>
                            </div>
                            <div className="col-lg-6 col-6">
                              <div className="two-right">
                                <h2>{t("C7")}</h2>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="cart-box3">
                          <div className="row card-right-center">
                            <div className="col-lg-6 col-6">
                              <div className="two-left two-left1">
                                <h2>{t("C17")}</h2>
                              </div>
                            </div>
                            <div className="col-lg-6 col-6">
                              <div className="two-right two-right1">
                                <h2>₹411</h2>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="cart-box4">
                          <div className="row card-right-center">
                            <div className="col-lg-12">
                              <div className="two-left two-left1">
                                <p>{t("C18")}</p>
                                <Link to ="/address" className="tm-button tm-button22 tm-button-dark">{t("C19")}</Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="tab-pane fade" id="account-orders" role="tabpanel" aria-labelledby="account-orders-tab">
              <div className="tm-myaccount-orders">
                <div className="table-responsive">
                  <table className="table table-bordered mb-0">
                    <thead>
                      <tr>
                        <th className="tm-myaccount-orders-col-id">{t("C20")}</th>
                        <th className="tm-myaccount-orders-col-date">{t("C21")}</th>
                        <th className="tm-myaccount-orders-col-status">{t("C22")}</th>
                        <th className="tm-myaccount-orders-col-total">{t("C23")}</th>
                        <th className="tm-myaccount-orders-col-view">{t("C24")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>#12345</td>
                        <td>{t("C25")}</td>
                        <td>{t("C26")}</td>
                        <td>{t("C27")}</td>
                        <td><a href="#" className="tm-button tm-button-small">{t("C24")}</a>
                        </td>
                      </tr>
                      <tr>
                        <td>#12346</td>
                        <td>{t("C25")}</td>
                        <td>{t("C26")}</td>
                        <td>{t("C28")}</td>
                        <td><a href="#" className="tm-button tm-button-small">{t("C24")}</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="tab-pane fade" id="account-address" role="tabpanel" aria-labelledby="account-address-tab">
              <div className="tm-myaccount-address">
                <p><b>{t("C29")}</b></p>
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="tm-myaccount-address-billing">
                      <a href="#" className="edit-button">{t("C36")}</a>
                      <h3>{t("C30")}</h3>
                      <address>
                      {t("C31")}<br />
                      {t("C32")}<br />
                      {t("C33")}<br />
                      {t("C34")}<br />
                      {t("C35")}
                      </address>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 mt-30 mt-md-0">
                    <div className="tm-myaccount-address-shipping">
                      <a href="#" className="edit-button">{t("C36")}</a>
                      <h3>{t("C37")}</h3>
                      <address>
                      {t("C31")}<br />
                      {t("C32")}<br />
                      {t("C33")}<br />
                      {t("C34")}<br />
                      {t("C35")}
                      </address>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="tab-pane fade" id="account-acdetails" role="tabpanel" aria-labelledby="account-acdetails-tab">
              <div className="tm-myaccount-acdetails">
                <form action="#" className="tm-form tm-form-bordered">
                  <h4>{t("C38")}</h4>
                  <div className="tm-form-inner">
                    <div className="tm-form-field tm-form-fieldhalf">
                      <label htmlFor="acdetails-firstname">{t("C39")}</label>
                      <input type="text" id="acdetails-firstname" />
                    </div>
                    <div className="tm-form-field tm-form-fieldhalf">
                      <label htmlFor="acdetails-lastname">{t("C40")}</label>
                      <input type="text" id="acdetails-lastname" />
                    </div>
                    <div className="tm-form-field">
                      <label htmlFor="acdetails-displayname">{t("C41")}</label>
                      <input type="text" id="acdetails-displayname" />
                    </div>
                    <div className="tm-form-field">
                      <label htmlFor="acdetails-email">{t("C42")}</label>
                      <input type="email" id="acdetails-email" />
                    </div>
                    <div className="tm-form-field">
                      <label htmlFor="acdetails-password">{t("C43")}</label>
                      <input type="password" id="acdetails-password" />
                    </div>
                    <div className="tm-form-field">
                      <label htmlFor="acdetails-newpassword">{t("C44")}</label>
                      <input type="password" id="acdetails-newpassword" />
                    </div>
                    <div className="tm-form-field">
                      <label htmlFor="acdetails-confirmpass">{t("C45")}</label>
                      <input type="password" id="acdetails-confirmpass" />
                    </div>
                    <div className="tm-form-field">
                      <input type="checkbox" name="acdetails-agreeterms" id="acdetails-agreeterms" />
                      <label htmlFor="acdetails-agreeterms">{t("C46")}</label>
                    </div>
                    <div className="tm-form-field">
                      <button type="submit" className="tm-button">{t("C47")}</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>

  )
}

export default Cart
